const formLabelStyles = (tokens) => ({
    baseStyle: {
        fontWeight: tokens.TextBodyMedium4FontWeight,
        fontSize: tokens.TextBodyMedium4FontSize,
        color: tokens.TextDark800,
        marginBottom: tokens.Spacing02,
    },
    variants: {
        small: {
            fontSize: tokens.TextBodyMedium4FontSize,
            marginBottom: tokens.Spacing01,
        },
        medium: {
            fontWeight: tokens.TextBodyReg3FontWeight,
            fontSize: tokens.TextBodyReg3FontSize,
        },
        large: {
            fontSize: tokens.TextHeadingMedium5FontSize,
            color: tokens.TextMedium600,
        },
    },
});
export default formLabelStyles;
